export const paymentMethod: { [key: number]: string } = {
  1: 'cash',
  2: 'financed',
  3: 'leasing',
  4: 'renting',
  5: 'rental',
};
